import PolygonBase from './PolygonBase';
import ShapeBase from './ShapeBase';
import shapePentagon from '../assets/icons/shapePentagon.svg';
import { svgToIcon } from '../utils/svg';

class ShapePentagon extends PolygonBase {
  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const verticalBound = height / 4.5;
    const horizontalBound = width / 5;
    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: 0,
    };
  }

  static renderIcon() {
    return svgToIcon(shapePentagon);
  }

  static pathString() {
    const points = this.polygonPoints(5, Math.PI * 1.5);
    this.dimensionsFromPoints(points);

    const scaleX = ShapeBase.defaultWidth() / this.width;
    const scaleY = ShapeBase.defaultHeight() / this.height;

    for (const p of points) {
      p.x *= scaleX;
      p.y *= scaleY;
    }

    // Compute the offset since the center of the pentagon is not in the
    // center of the bounding box using these formulae:
    //   rc = a / 10 * √ (50 + 10 * √5)
    //   ri = a / 10 * √ (25 + 10 * √5)
    const a = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
    const rc = (a / 10) * Math.sqrt(50 + 10 * Math.sqrt(5));
    const ri = (a / 10) * Math.sqrt(25 + 10 * Math.sqrt(5));
    const offsetY = (rc - ri) / 2;

    let path = `M ${points[0].x} ${points[0].y + offsetY}\n`;
    for (let i = 1; i < 5; i++) {
      path += `L ${points[i].x} ${points[i].y + offsetY}\n`;
    }
    path += 'Z';

    // TODO: look at ShapeStar.js code to see how to position the controls
    // better.

    return path;
  }
}

export default ShapePentagon;
